import ActionTypes from '../actions/actionTypes';

const initialState = {
  isLoading: false,
  roles: [],
  isError: false,
};

export function rolesReducer(state = initialState, { type, payload }) {
  let roles;
  switch (type) {
    case ActionTypes.ROLES.FETCH.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case ActionTypes.ROLES.FETCH.SUCCESS:
      roles = payload.roles;
      return {
        ...state,
        isLoading: false,
        roles,
      };
    case ActionTypes.ROLES.FETCH.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      return state;
  }
}

export function assignableRolesReducer(state = initialState, { type, payload }) {
  let roles;
  switch (type) {
    case ActionTypes.ROLES.ASSIGN_ROLES.RESET:
      return {
        ...state,
        isLoading: true,
        isError: false,
        roles: [],
      };
    case ActionTypes.ROLES.ASSIGN_ROLES.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case ActionTypes.ROLES.ASSIGN_ROLES.SUCCESS:
      roles = payload.roles;
      return {
        ...state,
        isLoading: false,
        roles,
      };
    case ActionTypes.ROLES.ASSIGN_ROLES.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      return state;
  }
}
